import './style.css';
import { getMaxSeverity } from 'store/alarms';
import { getConfigItem } from 'util/device';
import { Trans } from '@lingui/react/macro';


function StatusIcon({children, device, alarms, showOkay = true}) {
  const LOTO = getConfigItem(device.model, 'LockoutTagOut');
  const PowerState = getConfigItem(device.model, 'PowerState')?.value?.toLowerCase();
  const unassigned = Object.prototype.hasOwnProperty.call(device.model, 'assigned') && device.model.assigned === false;

  if (unassigned) {
    return (
      <span className="status-icon unassigned"><Trans>Unassigned</Trans></span>
    );
  }

  if (LOTO?.value == 'on') {
    return (
      <span className="status-icon locked-out"><Trans>Locked Out</Trans></span>
    );
  }

  if (
    alarms.length ||
    LOTO?.value == 'on' ||
    device.model.commStatus != 'ok' ||
    device.model.dataIsStale ||
    PowerState?.includes('forcedon') ||
    PowerState?.includes('disabled')
  ) {
    return (
      <span className={
      `
        status-icon
        ${device.model.commStatus != 'ok' ? `signal ${device.model.commStatus}` : ''}
        ${device.model.dataIsStale ? 'stale-data' : ''}
        ${alarms.length ? (device.model.type == 'Circuit' ? '' : 'attention') : ''}
        ${PowerState?.includes('forcedon') ? 'forced-on' : ''}
        ${PowerState?.includes('disabled') ? 'disabled' : ''}
        ${getMaxSeverity(alarms)}
      `}>
        {children}
      </span>
    );
  }

  if (showOkay) {
    return (
      <span className="status-icon ok"><Trans>OK</Trans></span>
    );
  }

  return null;
}

export default StatusIcon;
